import { AxiosResponse } from 'axios'
import React, { useEffect, useState } from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { Loading } from '../../../components/UI'
import { TypePosition } from '../../../components/TypePosition/types/TypePosition'
import { NewTypePositionEditForm } from './NewTypePositionEditForm'
import { getTypePositionById, updateTypePosition } from '../config/api'

interface NewTypePositionEditProps {
  isOpen: boolean
  typePositionId: number
  onClose: () => void
  onSuccess: (message: string) => void
  onError: (message: string) => void
}

export const NewTypePositionEdit: React.FC<NewTypePositionEditProps> = ({
  isOpen,
  typePositionId,
  onClose,
  onSuccess,
  onError
}) => {
  const [loading, setLoading] = useState(false)
  const [typePosition, setTypePosition] = useState<TypePosition | undefined>(undefined)

  const fetchTypePosition = () => {
    setLoading(true)
    getTypePositionById(typePositionId)
      .then(({ data }: AxiosResponse<TypePosition>) => {
        setTypePosition(data)
      })
      .catch((err) => {
        onError(`Error al cargar el tipo de posición: ${err}`)
        onClose()
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (isOpen && typePositionId > 0) {
      fetchTypePosition()
    } else {
      setTypePosition(undefined)
    }
  }, [isOpen, typePositionId])

  const handleSave = (modifiedData: TypePosition) => {
    setLoading(true)
    updateTypePosition(typePositionId, modifiedData)
      .then(() => {
        onSuccess('Tipo de posición actualizado correctamente')
        onClose()
      })
      .catch((err) => {
        onError(`Error al actualizar el registro: ${err}`)
      })
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title='Editar Tipo Posición'
      maxWidth='xs'
    >
      {loading || !typePosition ? (
        <Loading />
      ) : (
        <NewTypePositionEditForm 
          typePosition={typePosition} 
          onSubmit={handleSave}
          isSubmitting={loading}
        />
      )}
    </Modal>
  )
}
